import { useForm } from "react-hook-form";
import FillInformationForm from "./_components/FillInformationForm";
import { useFillInfoSendRequestMutation } from "../../apis/fleetApis";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useState } from "react";

type Props = {
  lineHaulRequestId?: string;
  queryParams?: any;
};

function parseQueryString(queryString: any) {
  const query = queryString.startsWith("?")
    ? queryString.slice(1)
    : queryString;

  return query.split("&").reduce((acc: any, pair: any) => {
    const [key, value] = pair.split("=");
    acc[key] = decodeURIComponent(value || "");
    return acc;
  }, {});
}

function FillInformation({ lineHaulRequestId }: Props) {
  const [showThankYou, setShowThankYou] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    clearErrors,
    reset,
    setError,
  } = useForm();
  const location = useLocation();

  const { mutate, isPending } = useFillInfoSendRequestMutation();

  const queryObject = parseQueryString(location?.search);

  const onSubmit = (data: any) => {
    mutate(
      { ...data, lineHaulRequestId: queryObject?.requestId },
      {
        onSuccess: () => {
          reset();
          setShowThankYou(true);
        },
        onError: (err: any) => {
          if (err?.errors) {
            err.errors.forEach((e: any) => {
              setError(e.field, { type: "server", message: e.message });
            });
          }
          console.log(err, "err");
          toast.error(
            err || err?.message || "Something went wrong. Please try again."
          );
        },
      }
    );
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FillInformationForm
          register={register}
          control={control}
          errors={errors}
          clearErrors={clearErrors}
          isPending={isPending}
          payload={queryObject}
        />
      </form>

      {showThankYou && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white rounded-xl p-8 w-[400px] text-center shadow-lg">
            <h2 className="text-2xl font-semibold mb-3">🎉 Thank You!</h2>
            <p className="text-gray-600 mb-6">
              Your information has been submitted successfully.
            </p>
            <button
              onClick={() => setShowThankYou(false)}
             className="px-4 py-2 bg-[#FFD74F] text-sm font-medium rounded-full"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default FillInformation;
